<div class="xgrid-debug">
  <div class="area area-images">
    <ideal-render-target-product-result-images
      image
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.Images]"
    ></ideal-render-target-product-result-images>
    <ideal-render-target-product-result-image-overlay
      images-overlay
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.ImagesOverlay]"
    ></ideal-render-target-product-result-image-overlay>
  </div>
  <div class="area area-important-info">
    <ideal-render-target-product-result-title
      title
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.Title]"
    ></ideal-render-target-product-result-title>

    <ideal-render-target-product-result-important-info
      important-info
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.ImportantInfo]"
    ></ideal-render-target-product-result-important-info>
  </div>

  <div class="area area-price">
    <ideal-render-target-product-result-price
      price
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.Price]"
    ></ideal-render-target-product-result-price>
  </div>
  <div class="area area-stock">
    <ideal-render-target-product-result-stock
      stock
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.Stock]"
    ></ideal-render-target-product-result-stock>
  </div>
  <div class="area area-actions">
    <ideal-render-target-product-result-actions
      actions
      *ifHasRenderInSources="LayoutComponents[LayoutTargets.Actions]"
    ></ideal-render-target-product-result-actions>
  </div>
</div>
@if (productReady()) {
  <a hit-box [routerLink]="['/products', productId()?.toString()]"></a>
}

<!--


<div class="grid-debug">
  <div content>
    <div class="col col-images">
      <ideal-render-target-product-result-images
        image
        *ifHasRenderInSources="LayoutComponents[LayoutTargets.Images]"
      ></ideal-render-target-product-result-images>
    </div>
    <div class="col col-important-info">
      <ideal-render-target-product-result-title
        title
        *ifHasRenderInSources="LayoutComponents[LayoutTargets.Title]"
      ></ideal-render-target-product-result-title>

      <ideal-render-target-product-result-important-info
        importantInfo
        *ifHasRenderInSources="LayoutComponents[LayoutTargets.ImportantInfo]"
      ></ideal-render-target-product-result-important-info>
    </div>
    <div class="col col-info">
      <ideal-render-target-product-result-info
        info
        *ifHasRenderInSources="LayoutComponents[LayoutTargets.Info]"
      ></ideal-render-target-product-result-info>
    </div>
    <div spacer></div>
    <div class="col col-price">
      <ideal-render-target-product-result-price
        price
        *ifHasRenderInSources="LayoutComponents[LayoutTargets.Price]"
      ></ideal-render-target-product-result-price>
    </div>
    <div class="col col-stock">
      <ideal-render-target-product-result-stock
        stock
        *ifHasRenderInSources="LayoutComponents[LayoutTargets.Stock]"
      ></ideal-render-target-product-result-stock>
    </div>
    <div class="col col-actions">
      <ideal-render-target-product-result-actions
        actions
        *ifHasRenderInSources="LayoutComponents[LayoutTargets.Actions]"
      ></ideal-render-target-product-result-actions>
    </div>
  </div>
</div> -->

@if (typeComponentInjector() && productTypeComponents()) {
  <div style="display: none">
    @for (component of productTypeComponents(); track $index) {
      <ng-container *ngComponentOutlet="component; injector: typeComponentInjector(); inputs: componentInputs()"></ng-container>
    }
  </div>
}
